import * as d3 from 'd3';
import { DefaultTheme } from 'styled-components';
import theme from 'src/theme/theme';

type Arguments = {
  graph: d3.Selection<null, unknown, null, undefined>;
  transform: string;
  width: number;
  axis: d3.Axis<d3.NumberValue> | d3.Axis<number>;
  hideAxisLine?: boolean;
  dashAxis: 'x2' | 'y2';
  theme?: DefaultTheme;
};
export const appendAxisAndTicks = ({
  axis,
  transform,
  graph,
  width,
  hideAxisLine,
  dashAxis,
  theme: t,
}: Arguments) => {
  const isAtlas = t && !t.isVaultVariant;
  const color = isAtlas
    ? t.atlas.semantic.color.type.default
    : theme.newPalette.neutral.N800;
  const dividerColor = isAtlas
    ? t.atlas.semantic.color.ui.divider.default
    : theme.newPalette.neutral.N300;
  graph
    .append('g')
    .attr('transform', transform)
    .style('font-size', theme.newTypography.textStyleBodySmall.fontSize)
    .style('font-family', theme.newTypography.textStyleBodySmall.fontFamily)
    .style('color', color)
    .call(axis)
    .call((g) => {
      hideAxisLine
        ? g.select('.domain').remove()
        : g.select('.domain').attr('stroke', dividerColor);
    })
    .call((g) =>
      g
        .selectAll('.tick line')
        .filter((d) => d !== 0)
        .clone()
        .attr(dashAxis, width)
        .attr('stroke', dividerColor)
        .style('stroke-dasharray', '5 5'),
    );
};
